import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { OmsServiceService } from '../../services/oms-service.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ConstantsService } from '../../services/constants.service';
import { SharedService } from '../../../../../tools/src/lib/shared/shared.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";
import { environment } from '../../../environments/environment';
import { NGB_DATEPICKER_DATE_ADAPTER_FACTORY } from '@ng-bootstrap/ng-bootstrap/datepicker/adapters/ngb-date-adapter';

@Component({
  selector: 'app-items-reassign-modal',
  templateUrl: './items-reassign-modal.component.html',
  styleUrls: ['./items-reassign-modal.component.scss']
})
export class ItemsReassignModalComponent implements OnInit {

  reassignVendorRequest = {};
  reassignVendorRes = {};
  lineItemCodesList: any[] = [];
  reassignVendorRequestInfo = {};
  reassignVendorInfoList = [];
  @Input() line_items;
  @Input() delivery_lat;
  @Input() delivery_lng;
  @Input() pincode;
  @Input() mode_of_service;
  @Input() order_id;
  @Input() business_id;
  @Input() provider_info;

  @Input() org_code;
  @Input() tenant_code;
  vendorInfoList: any[] = [];
  testNameList: any[] = [];
  lastkeydown: number = 0;

  totalPrice: number = 0;
  slotInfoRequest = {};
  OrderDateRes = {};
  slotResponse = {};
  reAssignForm: FormGroup;
  slotTimingInfo: string = null;
  selectedVendorObj: any;
  submitted: boolean = false;
  msg: string = "";
  isSuccessMsg :Boolean =false;
  isFailureMsg :Boolean =false;
  private apiKey= environment.apiKey;
  minDate = undefined;
  labAvailableTimings = [];

  labAvailableTimingsRes = {};

   selectedVendorAssociateCode:string="";
   @Input() labAvailable_TimingsRes;
  constructor(
    public modal: NgbActiveModal,
    private omsServiceService: OmsServiceService,
    private constantsService: ConstantsService,
    private sharedService: SharedService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private SpinnerService: NgxSpinnerService
  ) {
    this.reAssignForm = new FormGroup({
      vendorName: new FormControl("", [Validators.required]),
      testName: new FormControl(),
      price: new FormControl("", [Validators.required]),
      selectedDate: new FormControl("", [Validators.required]),
      slotTime: new FormControl("", [Validators.required]),
      reason: new FormControl("", [Validators.required]),
    });


  }


  ngOnInit(): void {
    this.totalPrice =0;
    const current = new Date();
    this.minDate = {
      year: current.getFullYear(),
      month: current.getMonth() + 1,
      day: current.getDate()
    };
    // this.line_items=[];
    //this.line_items = ["TS1500FACRICT0028"];
    // this.line_items.push("");
    let selectedVendor = "";
    for (let data of this.provider_info) {
      if (data.component_no == 7) {
        selectedVendor = data.associate_name;
       this.selectedVendorAssociateCode = data.associate_id +"_"+data.associate_branch_id;
        //console.log(selectedVendor);
      }
    }

    if (selectedVendor != null && selectedVendor != undefined) {


    }
    for (let i = 0; i < this.line_items.length; i++) {
      if (this.line_items[i].roleBasedService != 1 && this.line_items[i].item_status != 8) {
        this.lineItemCodesList.push(this.line_items[i].item_code);
        this.testNameList.push({ "testName": this.line_items[i].itemname, "netAmount": this.line_items[i].net_amount });
        this.totalPrice = this.totalPrice + this.line_items[i].net_amount;
      }

      // matches.push({ "vendorName": arr[i].associateName, "vendorCode": arr[i].associateCode, "associateBranchId": arr[i].associateBranchId });
      // this.testNameList.push({ "testName": this.line_items[i].itemname, "netAmount": this.line_items[i].net_amount });
      //this.totalPrice = this.totalPrice + this.line_items[i].net_amount;
    }
    //console.log(this.totalPrice);

    this.reAssignForm.setValue({ 'vendorName': "", 'testName': "", 'price': this.totalPrice, 'selectedDate': "", 'slotTime': '', 'reason': '' });
    this.getVendorInfo();
    this.labAvailableTimingsRes =this.labAvailable_TimingsRes[this.selectedVendorAssociateCode]["available_timing"];
    //console.log(this.labAvailableTimingsRes);
  }
  getVendorInfo() {
    this.reassignVendorRequest = {};
    this.reassignVendorRequest["method"] = "fetchservice/getServicesInfo";
    this.reassignVendorRequest["type"] = "post";

    //this.reassignVendorRequest["businessId"] = this.constantsService.BUSINESS_ID;
    //this.reassignVendorRequest["businessId"] = "4";
    this.reassignVendorRequest["businessId"] = this.business_id;
    this.reassignVendorRequest["lineItems"] = this.lineItemCodesList;
    //this.reassignVendorRequest["lineItems"] = ["TS1500FACRICT0028", "TS1500FACRICT0018"];

    this.reassignVendorRequest["lon"] = this.delivery_lng;
    //this.reassignVendorRequest["lon"] = "78.3665356";
    //this.reassignVendorRequest["lat"] = "17.4352303";
    this.reassignVendorRequest["lat"] = this.delivery_lat;
    //this.reassignVendorRequest["zipcode"] = "500032";
    this.reassignVendorRequest["zipcode"] = this.pincode;
    this.reassignVendorRequest["engage_at"] = this.constantsService.ENGAGE_AT;
    this.reassignVendorRequest["tenantCode"] = this.tenant_code;
    this.reassignVendorRequest["orgCode"] = this.org_code;
    //this.reassignVendorRequest["engage_at"] = this.mode_of_service;
    //console.log(this.reassignVendorRequest);
    this.omsServiceService.reAssignItems(this.reassignVendorRequest).subscribe(
      (res) => {
        //console.log(res);
        this.reassignVendorRes = res["data"];
        this.reassignVendorInfoList = res["data"];
        this.vendorInfoList = this.getVendorNames(this.reassignVendorRes);
        //console.log(this.vendorInfoList);

      }

    )

  }
  getVendorInfoList($event) {
    let vendorId = (<HTMLInputElement>document.getElementById('vendorInfoId')).value;

    if (vendorId.length > 4) {
      if ($event.timeStamp - this.lastkeydown > 200) {

        this.getVendorInfo();

      }
    }
  }

  getVendorNames(arr) {
    let matches = [], i;
    let addressObj = {};
    for (i = 0; i < arr.length; i++) {
      let obj = arr[i].associateAddress;

      obj = obj.replaceAll("{", "");
      obj = obj.replaceAll("}", "");
      obj = obj.replaceAll("=", ":");



      var jsonStrig = '[{';
      var items = obj.split(',');
      for (var j = 0; j < items.length; j++) {
        var current = items[j].split(':');
        jsonStrig += '"' + current[0] + '":"' + current[1] + '",';
      }
      jsonStrig = jsonStrig.substr(0, jsonStrig.length - 1);
      jsonStrig += '}]';

      addressObj = JSON.parse(jsonStrig)[0];

      matches.push({ "vendorName": arr[i].associateName + "," + JSON.parse(jsonStrig)[0][" city"] + "," + JSON.parse(jsonStrig)[0][" zipcode"], "vendorCode": arr[i].associateCode, "associateBranchId": arr[i].associateBranchId });
    }
    return matches;
  };
  getSlotData() {

    let fromDate = this.reAssignForm.get("selectedDate").value;
    let fromDateValue = fromDate.year + "-" + fromDate.month + "-" + fromDate.day;
    let selectedFromDate = this.sharedService.getStringDate(new Date(fromDateValue));

    return this.getData(selectedFromDate);
  }

  getData(dateEntered: string) {
   // this.slotInfoRequest["api_key"] = "91ADEF-F14F-4422-95211-1224THE";
    //this.slotInfoRequest["api_key"] = "31DEM-D42WA-P1144-ERD131-1ERT1";
    //dynamic api key
    this.slotInfoRequest["api_key"] = this.apiKey;
    this.slotInfoRequest["from_date"] = dateEntered;
    this.slotInfoRequest["to_date"] = dateEntered;
    this.slotInfoRequest["engagement_level"] = this.mode_of_service;
    //this.slotInfoRequest["role_id"] = this.constantsService.ROLE_ID;
    this.slotInfoRequest["role_id"] = window.localStorage.getItem('role');
    this.slotInfoRequest["pin_code"] = this.pincode;
    this.slotInfoRequest["business_id"] = this.business_id;
    this.slotInfoRequest["type"] = "post";
    this.slotInfoRequest["tenant_code"] = this.tenant_code;
    this.slotInfoRequest["organization_code"] = this.org_code;

    this.omsServiceService.getOrderDate(this.slotInfoRequest).subscribe(
      (res) => {
        //console.log(res["slots"][dateEntered]);
        this.OrderDateRes = res["slots"][dateEntered];
        this.slotResponse = res["slots"][dateEntered]

      });
  }

  submitReassignData(data) {


    this.submitted = true;

    if (this.reAssignForm.valid) {
      this.SpinnerService.show();
      let vendorCode = "";
      let vendorBranchId = "";
      let i;
      let vendorObj = data.controls.vendorName.value;
      for (i = 0; i < this.vendorInfoList.length; i++) {
        if (this.vendorInfoList[i].vendorName == vendorObj) {
          vendorCode = this.vendorInfoList[i].vendorCode;
          vendorBranchId = this.vendorInfoList[i].associateBranchId;
        }
      }
      let fromDate = data.controls.selectedDate.value;
      let fromDateValue = fromDate.year + "-" + fromDate.month + "-" + fromDate.day;
      let scheduledDate = this.sharedService.getStringDate(new Date(fromDateValue));

      let slotTime = data.controls.slotTime.value.from_time;
      scheduledDate = scheduledDate + " " + slotTime;
      this.reassignVendorRequestInfo["orderId"] = this.order_id;
      this.reassignVendorRequestInfo["reason"] = data.controls.reason.value;
      this.reassignVendorRequestInfo["vendorCode"] = vendorCode;
      this.reassignVendorRequestInfo["vendorBranchId"] = vendorBranchId;
      this.reassignVendorRequestInfo["scheduledDate"] = scheduledDate;
      this.reassignVendorRequestInfo["actionById"] = window.localStorage.getItem('actionById');;
      this.reassignVendorRequestInfo["actionByName"] = window.localStorage.getItem('actionByName');;
      this.reassignVendorRequestInfo["channelCode"] = this.constantsService.CHANNEL_CODE;
      this.reassignVendorRequestInfo["type"] = "post";
      this.reassignVendorRequestInfo["action"] = "OMS/api/operation.php/v4/vendor/reallocation";
      //console.log(this.reassignVendorRequestInfo);
      this.omsServiceService.reAssignItemsFormSubmit(this.reassignVendorRequestInfo).subscribe(
        (res) => {

          if (res["status"] == 1) {
            //alert(res["message"]);
            this.isSuccessMsg =true;
            this.msg = res["message"];
            //this.modal.close();
          } else {
            this.isFailureMsg =true;
            // alert(res["message"]);
            this.msg = res["message"];
            //this.modal.close();
          }
          this.SpinnerService.hide();

        });

    }
  }
  getPrice() {

    let selectedVendorName = (<HTMLInputElement>document.getElementById('vendorInfoId')).value;
    //console.log(selectedVendorName);


    let associate_id="";
    //vendorName
    for (let data of this.reassignVendorInfoList) {
      //console.log(data.code);
      //console.log(data.name);
      if (selectedVendorName.split(",")[0]== data.associateName && selectedVendorName.split(",")[2] ==this.getZipCode(data.associateAddress  )) {
        // this.enterTestName = this.addTestForm.get("testname").value;
        associate_id =data.associateId;
        this.reAssignForm.setValue({ 'vendorName': selectedVendorName, 'testName': this.testNameList, 'price': data.totalSellingPrice, 'selectedDate': '', 'slotTime': '', 'reason': '' })
      }

    }

    //console.log(associate_id);
    this.getAvilableLabTimings(associate_id);

  }

  modelClose() {

    this.modal.close();

  }


  convertStringToObject(obj) {

    let addressObj = {};

    obj = obj.replaceAll("{", "");
    obj = obj.replaceAll("}", "");
    obj = obj.replaceAll("=", ":");



    var jsonStrig = '[{';
    var items = obj.split(',');
    for (var i = 0; i < items.length; i++) {
      var current = items[i].split(':');
      jsonStrig += '"' + current[0] + '":"' + current[1] + '",';
    }
    jsonStrig = jsonStrig.substr(0, jsonStrig.length - 1);
    jsonStrig += '}]';

    addressObj = JSON.parse(jsonStrig)[0];
    // alert(obj[0].city);
    // JSON.parse(jsonStrig)[0].area
    return addressObj;
  }

  getZipCode(obj) {

    let addressObj = {};

    obj = obj.replaceAll("{", "");
    obj = obj.replaceAll("}", "");
    obj = obj.replaceAll("=", ":");



    var jsonStrig = '[{';
    var items = obj.split(',');
    for (var i = 0; i < items.length; i++) {
      var current = items[i].split(':');
      jsonStrig += '"' + current[0] + '":"' + current[1] + '",';
    }
    jsonStrig = jsonStrig.substr(0, jsonStrig.length - 1);
    jsonStrig += '}]';

    //addressObj = JSON.parse(jsonStrig)[0];
    // alert(obj[0].city);
    // JSON.parse(jsonStrig)[0].area
    return JSON.parse(jsonStrig)[0][" zipcode"];
  }

  getAvilableLabTimings(obj) {
    let labAvilableTimingsRequest = {};
    labAvilableTimingsRequest["actionById"] = window.localStorage.getItem('actionById');
    labAvilableTimingsRequest["channelCode"] = this.constantsService.CHANNEL_CODE;
    labAvilableTimingsRequest["assocData"] = [obj];




    this.omsServiceService.getLabTimings(labAvilableTimingsRequest).subscribe(
      (res) => {

        if (res["status"] == 1) {
           //console.log(res);
           
         this.labAvailableTimingsRes =res["data"][obj]["available_timing"];
         //console.log(this.labAvailableTimingsRes);

        }


      }
    )
  }
}
